import React from 'react';
import noCustomerIcon from '../../../../../assets/svg/profile.svg';

const NoCustomers = () => {
  return (
    <div style={{ textAlign: 'center', marginTop: 100 }}>
      <img
        src={noCustomerIcon}
        alt="هیچ رکوردی یافت نشد."
        height={60}
        width={60}
      />
      <div>صاحب باری یافت نشد.</div>
    </div>
  );
};

export default React.memo(NoCustomers);
